import { defaultMagneticMediaReport } from "./state";

/**
 * Formats
 */
export function setFormats(state, data) {
    state.magneticMediaFormats.table.data = data;
}

export function setFormat(state, data) {
    state.magneticMediaFormats.form = JSON.parse(JSON.stringify(data));
}

export function resetFormat(state) {
    state.magneticMediaFormats.form = {
        code: "",
        description: ""
    };
}

export function setLoadingCreateOrUpdateFormat(state, value) {
    state.magneticMediaFormats.loading = value;
}

export function setLoadingTableFormat(state, value) {
    state.magneticMediaFormats.table.loading = value;
}

/**
 * Concepts
 */

export function setConcepts(state, data) {
    state.magneticMediaConcepts.table.data = data;
}

export function setConcept(state, data) {
    state.magneticMediaConcepts.form = JSON.parse(JSON.stringify(data));
}

export function resetConcept(state) {
    state.magneticMediaConcepts.form = {
        code: "",
        description: ""
    };
}

export function resetConcepts(state) {
    state.magneticMediaConcepts.table.data = [];
}

export function setLoadingCreateOrUpdateConcept(state, value) {
    state.magneticMediaConcepts.loading = value;
}

export function setLoadingTableConcept(state, value) {
    state.magneticMediaConcepts.table.loading = value;
}

/**
 * Columns
 */
export function setColumns(state, data) {
    state.magneticMediaColumns.table.data = data;
}

export function setColumn(state, data) {
    const item = JSON.parse(JSON.stringify(data));

    state.magneticMediaColumns.form = {
        ...item,
        contact: undefined,
        regime: undefined
    };
}

export function resetColumn(state) {
    state.magneticMediaColumns.form = {
        number: "",
        title: "",
        description: "",
        vr_selection: "",
        limit_value: "",
        regime_id: "",
        contact_id: "",
        magnetic_media_concept_id: ""
    };
}

export function resetColumns(state) {
    state.magneticMediaColumns.table.data = [];
}

export function setVrSelectionOptions(state, data) {
    state.magneticMediaColumns.vrSelectionOptions = data;
}

export function setRegimeOptions(state, data) {
    state.magneticMediaColumns.regimeOptions = data;
}

export function setContacts(state, data) {
    state.magneticMediaColumns.contacts = data;
}

export function setLoadingCreateOrUpdateColumn(state, value) {
    state.magneticMediaColumns.loading = value;
}

export function setLoadingTableColumn(state, value) {
    state.magneticMediaColumns.table.loading = value;
}

/**
 * RangeAccounts
 */
export function setRangeAccounts(state, data) {
    state.magneticMediaRangeAccounts.table.data = data;
}

export function setRangeAccount(state, data) {
    state.magneticMediaRangeAccounts.form = JSON.parse(JSON.stringify(data));
}

export function resetRangeAccount(state) {
    state.magneticMediaRangeAccounts.form = {
        account_from_id: "",
        account_to_id: ""
    };
}

export function resetRangeAccounts(state, data) {
    state.magneticMediaRangeAccounts.table.data = data;
}

export function setLoadingCreateOrUpdateRangeAccount(state, value) {
    state.magneticMediaRangeAccounts.loading = value;
}

export function setLoadingTableRangeAccount(state, value) {
    state.magneticMediaRangeAccounts.table.loading = value;
}

/**
 * Reports
 */
export function setMagneticMediaReport(state, data) {
    const magneticMediaReportCopy = defaultMagneticMediaReport();
    const columnsStatics = magneticMediaReportCopy.columns.map(
        item => item.field
    );
    let columnsDynamic = [];

    if (data.length > 0) {
        columnsDynamic = Object.keys(data[data.length - 1]).filter(
            item => !columnsStatics.includes(item)
        );
    }

    const columns = [
        ...magneticMediaReportCopy.columns,
        ...columnsDynamic.map(item => ({
            headerName: item,
            field: item,
            width: 150,
            resizable: true,
            sortable: true,
            filter: true,
            isMoney: true,
            editable: false
        }))
    ];

    state.magneticMediaReport.columns = columns;
    state.magneticMediaReport.data = data;
}

export function setLoadingMagneticMediaReport(state, value) {
    state.magneticMediaReport.loading = value;
}

export function setTypesIdent(state, data) {
    state.magneticMediaReport.typesIdent = data
        .map(item => item.alphanum_data_first)
        .sort((a, b) => a.localeCompare(b));
}

export function setChangeDep(state) {
    state.onChangeDep++;
}

export function setMagneticMediaCurrentEditContact(state, data) {
    state.magneticMediaCurrentEditContact = data;
}



// WEBPACK FOOTER //
// ./src/modules/magneticMedia/mutations.js